import { render } from "./LPTable.vue?vue&type=template&id=eb5919a0&scoped=true"
import script from "./LPTable.vue?vue&type=script&lang=js"
export * from "./LPTable.vue?vue&type=script&lang=js"

import "./LPTable.vue?vue&type=style&index=0&id=eb5919a0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5919a0"]])

export default __exports__